import nullsyValueToEmptyString from './nullsyValueToEmptyString';
import _ from 'lodash';

function appendParams(path, search, params) {
    if (params) {
        for (let param in params) {
            if (params.hasOwnProperty(param)) {
                let value = nullsyValueToEmptyString(params[param]);

                if (_.isArray(value)) {
                    _.each(value, function (item) {
                        item = nullsyValueToEmptyString(item);
                        search.push(path + param + '=' + encodeURIComponent(item));
                    });
                }
                else if (_.isObject(value)) {
                    appendParams(param + '.', search, value);
                }
                else {
                    search.push(path + param + '=' + encodeURIComponent(value));
                }
            }
        }
    }
}

export default function (params) {
    const search = [];
    appendParams('', search, params);
    return search.join('&');
}